/**
 * 模板库弹层（P-A3）：列出已保存的画布模板，支持导入到当前画布 / 删除。
 * 竞品「保存为个人/团队模板、一键复用」的对齐实现（团队模板待后端）。
 */
import { Modal } from '../../ui/Modal';
import type { TemplateMeta } from '../../features/canvas/canvasLibrary';

interface TemplatesModalProps {
  open: boolean;
  templates: TemplateMeta[];
  onClose: () => void;
  onImport: (id: string) => void;
  onDelete: (id: string) => void;
}

export function TemplatesModal({ open, templates, onClose, onImport, onDelete }: TemplatesModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="模板库"
      summary="把常用的创作流程存为模板，新项目一键导入复用（团队共享模板待接入后端）。"
      footer={
        <button type="button" className="btn-ghost px-3 py-1.5 text-ui" onClick={onClose}>
          关闭
        </button>
      }
    >
      {templates.length === 0 ? (
        <p className="py-8 text-center text-uiSm text-ink-muted">还没有模板。选中节点后点「存为模板」即可创建。</p>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {templates.map((t) => (
            <div key={t.id} className="flex flex-col gap-2 rounded-card border border-surface-line bg-surface-base/40 p-3">
              <div className="h-20 overflow-hidden rounded-control border border-surface-line bg-surface-base">
                {t.cover !== undefined && <img src={t.cover} alt="" className="h-full w-full object-cover" />}
              </div>
              <div className="truncate text-ui font-semibold">{t.name}</div>
              <div className="text-uiSm text-ink-muted">{t.nodeCount} 个节点</div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => onImport(t.id)}
                  className="btn-primary flex-1 px-2 py-1 text-uiSm"
                >
                  导入
                </button>
                <button
                  type="button"
                  onClick={() => onDelete(t.id)}
                  className="rounded-control px-2 py-1 text-uiSm text-ink-muted hover:text-state-danger"
                >
                  删除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
